import { MapNotification } from "@services/API/MapData";
import { apiCall, apiPrefix } from "@services/API/Requests";
import { handleResponse } from "@services/API/StatusCodes";

export const getNotificationsData = async (
  setNotificationData: (data: any) => void,
  setTotalNotifications: (count: number) => void,
  setLoading: (loading: boolean) => void,
  setError: (error: any) => void,
  fromHomePage: boolean,
  currentPage: number,
  itemsPerPage: number,
  query = "",
) => {
  const queryString = query || "";
  const uri = fromHomePage
    ? `${apiPrefix}/notifications?status=true&current_page=${currentPage}&per_page=${itemsPerPage}${queryString}`
    : `${apiPrefix}/notifications?current_page=${currentPage}&per_page=${itemsPerPage}${queryString}`;

  return apiCall({
    method: "get",
    url: uri,
    setLoading,
    onSuccess: (response) => {
      const notifications = response.data.notifications.map(MapNotification);

      setNotificationData(notifications);
      setTotalNotifications(response.data.total_count);
      return handleResponse(response, "お知らせ");
    },
    onError: (errorResponse) => {
      const error =
        errorResponse.errors || errorResponse.error || errorResponse;
      setError(error);
    },
  });
};

export const getNotificationData = async (
  setNotificationData: (data: any) => void,
  setLoading: (loading: boolean) => void,
  setError: (error: any) => void,
  notificationId: string,
) => {
  if (!notificationId) return;

  return apiCall({
    method: "get",
    url: `${apiPrefix}/notifications/${notificationId}`,
    setLoading,
    onSuccess: (response) => {
      const data = response.data;
      const notification = MapNotification(data);

      setNotificationData(notification);
      return handleResponse(response, "お知らせ");
    },
    onError: (errorResponse) => {
      const error =
        errorResponse.errors || errorResponse.error || errorResponse;
      setError(error);
    },
  });
};

export const putNotificationData = async (
  notificationData: any,
  setLoading: (loading: boolean) => void,
  setError: (error: any) => void,
  notificationId: string,
) => {
  if (!notificationId || !notificationData) return;

  return apiCall({
    method: "put",
    url: `${apiPrefix}/notifications/${notificationId}`,
    data: notificationData,
    setLoading,
    onSuccess: (response) => {
      return handleResponse(response, "お知らせ");
    },
    onError: (errorResponse) => {
      const error =
        errorResponse.errors || errorResponse.error || errorResponse;
      setError(error);
    },
  });
};

export const postNotificationData = async (
  notificationData: any,
  setLoading: (loading: boolean) => void,
  setError: (error: any) => void,
) => {
  if (!notificationData) return;

  return apiCall({
    method: "post",
    url: `${apiPrefix}/notifications/`,
    data: notificationData,
    setLoading,
    onSuccess: (response) => {
      return handleResponse(response, "お知らせ");
    },
    onError: (errorResponse) => {
      const error =
        errorResponse.errors || errorResponse.error || errorResponse;
      setError(error);
    },
  });
};
